import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import Vue from "vue";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { UserFriendRequest } from "@/modules/users/viewmodels/UserFriendRequest";

// state
export const state = {
  incomingFriendRequests: [],
  outgoingFriendRequests: [],
};

export const getters = Object.assign(
  {
    incomingFriendRequest: (state) => (RequestId) => {
      return state.incomingFriendRequests.find((e) => e.id === RequestId);
    },
    incomingFriendRequests: (state) => {
      return state.incomingFriendRequests;
    },
    incomingFriendRequestUser: (state) => (UserId) => {
      return state.incomingFriendRequests.find(
        (e) => e.user_id_friend === UserId
      );
    },
    outgoingFriendRequest: (state) => (RequestId) => {
      return state.outgoingFriendRequests.find((e) => e.id === RequestId);
    },
    outgoingFriendRequests: (state) => {
      return state.outgoingFriendRequests;
    },
    outgoingFriendRequestUser: (state) => (UserId) => {
      return state.outgoingFriendRequests.find(
        (e) => e.user_id_friend === UserId
      );
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/users-friends-requests",
    UserFriendRequest,
    {},
    {
      /**
       * Returns my pending incoming friendrequests
       * this.$store.getters['userfriendrequest/api'].Custom.My()
       */
      Incoming: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "get",
            process.env.VUE_APP_BASE_URL + "/api/users-friends-requests/my"
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new UserFriendRequest(Entry);
        });

        Vue.set(state, "incomingFriendRequests", data);

        return data;
      },
      /**
       * Returns my outgoing pending friendrequests
       * this.$store.getters['userfriendrequest/api'].Custom.Outgoing()
       */
      Outgoing: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "get",
            process.env.VUE_APP_BASE_URL +
              "/api/users-friends-requests/outgoing"
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new UserFriendRequest(Entry);
        });

        Vue.set(state, "outgoingFriendRequests", data);

        return data;
      },

      /**
       * Accepts a friendrequest
       * this.$store.getters['userfriendrequest/api'].Custom.Accept(RequestId)
       */
      Accept: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "post",
            process.env.VUE_APP_BASE_URL +
              "/api/users-friends-requests/" +
              Id +
              "/accept"
          )
          .catch((err) => {
            throw Error(err);
          });

        Vue.set(
          state,
          "incomingFriendRequests",
          state.incomingFriendRequests.filter((e) => e.id !== Id)
        );

        return ApiResult;
      },

      /**
       * Rejects a friendrequest
       * this.$store.getters['userfriendrequest/api'].Custom.Reject(RequestId)
       */
      Reject: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "post",
            process.env.VUE_APP_BASE_URL +
              "/api/users-friends-requests/" +
              Id +
              "/reject"
          )
          .catch((err) => {
            throw Error(err);
          });

        Vue.set(
          state,
          "incomingFriendRequests",
          state.incomingFriendRequests.filter((e) => e.id !== Id)
        );

        return ApiResult;
      },
    }
  )
);

// mutations
export const mutations = {
  removeIncomingFriendRequest: (state, RequestId) => {
    let requestIndex = state.incomingFriendRequests.findIndex(
      (e) => e.id === RequestId
    );
    if (requestIndex !== undefined || requestIndex !== null) {
      state.incomingFriendRequests.splice(requestIndex, 1);
    }
  },
};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/users-friends-requests",
  [],
  {
    async removeIncomingFriendRequest({ commit }, RequestId) {
      commit("removeIncomingFriendRequest", RequestId);
    },
  }
);
